module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-Bd.8971c40.woff";